import { getLanguageName, isSupportedLocale, localeCodeToUrl, locales } from "./locale.mjs";
import { a as footer, i as header, n as mapHeader, r as slicePage, t as GatsbyClient } from "./gatsby-client-Nkjavnkw.mjs";
import * as prismic from "@prismicio/client";
import { isFilled } from "@prismicio/client";
//#region src/adapters/prismic/types/link.ts
let PrismicLinkTypeEnum = /* @__PURE__ */ function(PrismicLinkTypeEnum) {
	PrismicLinkTypeEnum["Any"] = "Any";
	PrismicLinkTypeEnum["Document"] = "Document";
	PrismicLinkTypeEnum["Media"] = "Media";
	PrismicLinkTypeEnum["Web"] = "Web";
	PrismicLinkTypeEnum["File"] = "File";
	return PrismicLinkTypeEnum;
}({});
//#endregion
//#region src/adapters/static/404-page.ts
const notFoundPage = {
	id: "en-us-not-found-page",
	uid: null,
	url: null,
	type: "not_found_page",
	href: "",
	tags: [],
	first_publication_date: "2024-03-14T08:12:23+0000",
	last_publication_date: "2024-03-14T08:12:23+0000",
	slugs: ["not-found-page"],
	linked_documents: [],
	lang: "en-us",
	alternate_languages: [],
	data: {
		meta_title: null,
		meta_description: null,
		open_graph_image: { url: null },
		title: "Oh no, it's a 404.",
		body: "We couldn't find the page you were looking for.",
		cta_text: "Check our homepage",
		cta_link: {
			id: "",
			tags: [],
			link_type: "Document",
			uid: "homepage",
			type: "homepage_v4",
			lang: "en-us",
			target: null,
			url: "/us",
			isBroken: false
		},
		exclude_sitemap: false
	}
};
//#endregion
//#region src/adapters/static/explore-product.ts
const exploreProductPage = {
	meta_title: "Explore Pleo",
	meta_description: "Explore how Expense management can be a breeze",
	open_graph_image: { url: "https://prismic-io.s3.amazonaws.com/commercial-helios/36a93715-9ce9-482f-88a2-4ad8b43c6b98_How%20it%20works%20-%20macbook%202.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max" },
	navattic_link: { url: "https://pleo.navattic.com/11iv0gjd" },
	navattic_link_staging: { url: "https://pleo.navattic.com/m33m0eb1" },
	interactive_demo_frame_title: "Interactive Demo",
	mobile_modal: [{
		subtitle: "Our product tour is best experienced on a desktop browser",
		button_text: "Return to homepage",
		link_text: "Continue to demo",
		image: {
			alt: null,
			url: "https://prismic-io.s3.amazonaws.com/commercial-helios/069ff477-adc9-400d-ab62-8e38123bb48f_explore-product-icon.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			copyright: null,
			dimensions: {
				height: 80,
				width: 80
			}
		}
	}]
};
//#endregion
//#region src/adapters/static/social-links.ts
const socialLinks = [
	{
		platform: "linkedin",
		name: "LinkedIn",
		url: "https://www.linkedin.com/company/pleo-company"
	},
	{
		platform: "twitter",
		name: "Twitter",
		url: "https://www.twitter.com/pleo"
	},
	{
		platform: "facebook",
		name: "Facebook",
		url: "https://www.facebook.com/pleo.io"
	},
	{
		platform: "instagram",
		name: "Instagram",
		url: "https://www.instagram.com/pleo.io"
	},
	{
		platform: "youtube",
		name: "YouTube",
		url: "https://www.youtube.com/channel/UCQQitvQIlEgIxNyLlOgilXQ"
	}
];
//#endregion
//#region src/adapters/static/getting-started-experience.ts
const gettingStartedExperiencePage = {
	meta_title: "Getting Started With Pleo",
	meta_description: "Signup flow",
	open_graph_image: { url: "https://commercial-helios.cdn.prismic.io/commercial-helios/f24d112a-d44d-40e9-836a-ad90142fae4f_pleo%20financial%20institution.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max" },
	back_to_home_page_text: "Back to homepage",
	account_question: "Does your business already have a Pleo account in one of our markets?",
	account_option_1_label: "Yes",
	account_option_1_description: "We have a Pleo account",
	account_option_1_icon: { fluid: { base64: "data:image/svg+xml;base64,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" } },
	account_option_2_label: "No",
	account_option_2_description: "We don’t have a Pleo account",
	account_option_2_icon: { fluid: { base64: "data:image/svg+xml;base64,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" } },
	account_option_3_label: "I don’t know",
	account_option_3_description: "Find out more about Pleo",
	account_option_3_icon: { fluid: { base64: "data:image/svg+xml;base64,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" } },
	existing_client_title: "Ask your company's Pleo admin to get you set up",
	existing_client_description: "Sign up to your Pleo admin to get your US entity set up. If you're an admin, simply add your US entity via the Pleo web app.",
	existing_client_help_title: "Need help?",
	existing_client_help_text: { richText: [{
		type: "paragraph",
		text: "Find out how to access and manage multiple entities for your company in our Help Center",
		spans: [{
			start: 76,
			end: 87,
			type: "hyperlink",
			data: {
				link_type: "Web",
				url: "https://help.pleo.io/en/articles/6394286-what-is-multi-entity-management",
				target: "_blank"
			}
		}]
	}] },
	existing_client_wistia_id: "uua2n5vxuy",
	existing_client_wistia_thumbnail: {
		url: "https://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
		alt: "",
		copyright: "",
		dimensions: {
			width: 1280,
			height: 697
		},
		gatsbyImageData: {
			images: {
				sources: [],
				fallback: {
					src: "https://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1280&h=697",
					srcSet: "https://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=392 720w,\nhttps://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=512 940w,\nhttps://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=588 1080w,\nhttps://images.prismic.io/commercial-helios/53770743-e020-4e20-ad24-759231a0b114_existing-client-thumbnail.webp?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1280&h=697 1280w",
					sizes: "(max-width: 768px) calc(100vw - 48px), (max-width: 991px) calc(100vw - 160px), (max-width: 1439px) calc(100vw - 232px), 680px"
				}
			},
			layout: "constrained",
			width: 1280,
			height: 697
		}
	},
	waiting_list_title: "Coming soon to a country near you",
	waiting_list_description: "You need to have a business entity in one of our existing markets to be a Pleo customer. Join our waiting list and we'll be in touch when we’ve landed in your country.",
	form_staging: {
		formId: "2a52e3a7-be21-47d3-a43d-9cb7145e2d62",
		consents: {
			type: "implicit_consent_to_process",
			communicationConsents: [{
				id: 108196403,
				required: true
			}]
		}
	},
	form_production: {
		formId: "26a8271c-fb92-4dfd-a210-317fbbd2fe45",
		consents: {
			type: "implicit_consent_to_process",
			communicationConsents: [{
				id: 5355469,
				required: false
			}]
		}
	},
	form_submit_text: "Join waiting list",
	success_message_title: "You're on the list!",
	success_message_description: "We’ll be in touch when Pleo is available in your country.",
	success_image: {
		alt: "",
		copyright: "",
		url: "https://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
		dimensions: {
			height: 1201,
			width: 1200
		},
		gatsbyImageData: {
			images: {
				sources: [],
				fallback: {
					src: "https://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1201",
					srcSet: "https://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=721 720w,\nhttps://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=941 940w,\nhttps://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=1081 1080w,\nhttps://images.prismic.io/commercial-helios/29a57817-6dc1-4f44-8b02-c71b394a6886_On%20the%20list-min.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=1201 1200w",
					sizes: "(max-width: 760px) calc(100vw - 48px), 540px"
				}
			},
			layout: "constrained",
			width: 1200,
			height: 1201
		}
	},
	multi_entity_title: "You've got an entity in {{countryName}}? Great!",
	multi_entity_description: "Let's head to Pleo's {{countryName}} site to get you signed up.",
	multi_entity_get_started_button_text: "Get Started with Pleo",
	multi_entity_book_a_demo_button_text: "Contact sales",
	multi_entity_banner_title: "Need help?",
	multi_entity_banner_description: { richText: [{
		type: "paragraph",
		text: "Learn how to get started with Pleo in our Help Center",
		spans: [{
			start: 42,
			end: 53,
			type: "hyperlink",
			data: {
				link_type: "Web",
				url: "https://help.pleo.io/en/collections/3109603-getting-started"
			}
		}]
	}] },
	multi_entity_banner_image: {
		alt: "",
		copyright: "",
		url: "https://images.prismic.io/commercial-helios/c8dbcb3b-4232-4899-bde9-61175600e6b1_Help%20centre%201.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C2099%2C1359&w=760&h=492",
		dimensions: {
			height: 492,
			width: 760
		},
		gatsbyImageData: {
			images: {
				sources: [],
				fallback: {
					src: "https://images.prismic.io/commercial-helios/c8dbcb3b-4232-4899-bde9-61175600e6b1_Help%20centre%201.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C2099%2C1359&w=760&h=492",
					srcSet: "https://images.prismic.io/commercial-helios/c8dbcb3b-4232-4899-bde9-61175600e6b1_Help%20centre%201.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C2099%2C1359&w=720&h=466 720w,\nhttps://images.prismic.io/commercial-helios/c8dbcb3b-4232-4899-bde9-61175600e6b1_Help%20centre%201.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C2099%2C1359&w=760&h=492 760w",
					sizes: "(max-width: 769px) calc(100vw - 48px), 540px"
				}
			},
			layout: "constrained",
			width: 760,
			height: 492
		}
	},
	entity_title: "Does your business have an entity in Europe or the UK?",
	entity_description: "If you have a business entity in one of our existing markets, sign up to Pleo in that country and set up your US entity.",
	entity_select_label: "Our company has an entity in:",
	entity_select_placeholder: "Choose a country",
	entity_no_entity_option: "We don't have an entity in Europe or the UK",
	entity_i_dont_know_option: "I'm not sure if we have an entity in Europe or the UK",
	entity_continue_button: "Continue",
	where_pleo_operates_label: "Where Pleo operates:",
	where_pleo_operates_img: {
		url: "https://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
		alt: "",
		copyright: "",
		dimensions: {
			width: 1200,
			height: 889
		},
		gatsbyImageData: {
			images: {
				sources: [],
				fallback: {
					src: "https://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=889",
					srcSet: "https://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=720&h=533 720w,\nhttps://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=940&h=696 940w,\nhttps://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1080&h=800 1080w,\nhttps://images.prismic.io/commercial-helios/7b4a9ed3-11cc-447b-a773-83105dab4cb3_pleo-map.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=1200&h=889 1200w",
					sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(50vw - 2 * 24px), (max-width: 1439px) calc(50vw - 2 * 40px), 600px"
				}
			},
			layout: "constrained",
			width: 1200,
			height: 889
		}
	},
	marquee_title: "Trusted by 40,000+ customers",
	images: [
		{ image: {
			alt: "Paddle Logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/398ec6d7-00eb-4f74-aea5-169d2cfc5436_Paddle.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/398ec6d7-00eb-4f74-aea5-169d2cfc5436_Paddle.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/398ec6d7-00eb-4f74-aea5-169d2cfc5436_Paddle.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "Cobee Logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/174008d4-c4ad-4332-b872-4539cbe21a9e_Cobee.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/174008d4-c4ad-4332-b872-4539cbe21a9e_Cobee.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/174008d4-c4ad-4332-b872-4539cbe21a9e_Cobee.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "Just Eat Logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/6e93443d-57c3-42dc-859f-af4d413bdd26_Just%20Eat.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/6e93443d-57c3-42dc-859f-af4d413bdd26_Just%20Eat.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/6e93443d-57c3-42dc-859f-af4d413bdd26_Just%20Eat.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "finetwork logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/7ab9feea-06ea-49cd-968e-6720428103ea_Finetwork.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/7ab9feea-06ea-49cd-968e-6720428103ea_Finetwork.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/7ab9feea-06ea-49cd-968e-6720428103ea_Finetwork.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "Thread Logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/be2ba611-cca2-4433-b1fe-9e7ba68941c0_Thread.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/be2ba611-cca2-4433-b1fe-9e7ba68941c0_Thread.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/be2ba611-cca2-4433-b1fe-9e7ba68941c0_Thread.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "medopad logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a3f2c1b5-70f9-455a-b75c-000a6de47d54_medopad.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/a3f2c1b5-70f9-455a-b75c-000a6de47d54_medopad.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/a3f2c1b5-70f9-455a-b75c-000a6de47d54_medopad.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "Planday logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a6ca57bc-3437-474c-aa4f-fc8997b202af_Planday.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/a6ca57bc-3437-474c-aa4f-fc8997b202af_Planday.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/a6ca57bc-3437-474c-aa4f-fc8997b202af_Planday.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} },
		{ image: {
			alt: "Foreo Logo",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/17fac5d2-2f13-44ca-b419-73b032cc8239_Foreo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 60,
				width: 100
			},
			gatsbyImageData: {
				images: {
					sources: [],
					fallback: {
						src: "https://commercial-helios.cdn.prismic.io/commercial-helios/17fac5d2-2f13-44ca-b419-73b032cc8239_Foreo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60",
						srcSet: "https://commercial-helios.cdn.prismic.io/commercial-helios/17fac5d2-2f13-44ca-b419-73b032cc8239_Foreo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&w=100&h=60 100w",
						sizes: "(min-width: 100px) 100px, 100vw"
					}
				},
				layout: "constrained",
				width: 100,
				height: 60
			}
		} }
	]
};
//#endregion
//#region src/adapters/static/pricing-page.ts
const pricingPage = {
	pricing: {
		meta_title: "Simple pricing that works for everyone",
		meta_description: "",
		exclude_robots: false,
		open_graph_image: {
			alt: "",
			copyright: "",
			url: "https://images.prismic.io/commercial-helios/911e202a-2769-41f0-ad5a-609d35af378d_meta-pricing-01.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
			dimensions: {
				height: 685,
				width: 1300
			}
		},
		table_title_image: {
			alt: "",
			copyright: "",
			url: "https://commercial-helios.cdn.prismic.io/commercial-helios/aJMbzqTt2nPbZ5ML_Compareplans-EN-1-.svg",
			dimensions: {
				width: 212,
				height: 107
			}
		},
		title: { richText: [{
			type: "paragraph",
			text: "Save time and money with our plans",
			spans: []
		}] },
		tables_title: "Wanna know more? Let's dig deeper",
		tables_tick_screen_reader_alt: "",
		feature_block: [],
		pricingTiersCtasLabels: [],
		tiers: [
			"essential",
			"advanced",
			"beyond"
		],
		comparison_layover: [{
			advanced_description: "$99 per month | 3 users included",
			beyond_description: "Bespoke",
			essential_description: "$39 per month | 1 user included",
			heading: "Choose another plan to compare",
			starter_description: ""
		}],
		form_production: {},
		form_staging: {},
		comparison_tables: [
			{ comparison_table: { document: {
				id: "2e78489d-ae80-5411-b309-98cd021580c6",
				data: {
					title: "Team",
					features: [
						{
							name: "Included users",
							tooltip_description: null,
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: "1",
							essential_excerpt: "3",
							advanced_excerpt: "3",
							beyond_excerpt: "3"
						},
						{
							name: "Maximum users",
							tooltip_description: null,
							starter1: true,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: "3",
							essential_excerpt: "Unlimited",
							advanced_excerpt: "Unlimited",
							beyond_excerpt: "Unlimited"
						},
						{
							name: "Reimbursement-only users",
							tooltip_description: "Allow employees to submit expenses for reimbursement without a company card.",
							starter1: true,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: "3",
							essential_excerpt: "See price per user",
							advanced_excerpt: "See price per user",
							beyond_excerpt: "100+"
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aRYf2hIAACUAorep",
				id: "f5612a43-6caf-5996-9f7e-4c4dc3b67797",
				data: {
					title: "Cards",
					features: [
						{
							name: "Physical and virtual Pleo cards",
							tooltip_description: "Give your team company cards for work expenses.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "ATM withdrawals",
							tooltip_description: "Withdraw cash for free. Foreign exchange fees may apply",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: "$5 per withdrawal",
							essential_excerpt: "Free",
							advanced_excerpt: "Free",
							beyond_excerpt: "Free"
						},
						{
							name: "Temporary virtual cards",
							tooltip_description: "Create virtual cards for projects, contractors, or work trips with set limits and expiration dates.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: "10+ per month"
						},
						{
							name: "Cashback (for eligible customers)",
							tooltip_description: "Earn cashback on company card spending (T&Cs apply).",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aRYgehIAACIAoric",
				id: "0173c565-3343-5936-9d72-a78c22a6cece",
				data: {
					title: "Expense management",
					features: [
						{
							name: "Automated receipt reminders",
							tooltip_description: "Remind employees to upload their receipts in the Pleo app.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Email receipt capture - Fetch",
							tooltip_description: "Auto-fetch and match email receipts to Pleo card transactions.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Out-of-pocket expense reporting",
							tooltip_description: "Track expenses paid for with personal funds and manage reimbursements.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Direct reimbursements",
							tooltip_description: "Reimburse employees to their bank account via Pleo – no need to wait for payday.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: "0.9%",
							advanced_excerpt: "0.9%",
							beyond_excerpt: "0.9%"
						},
						{
							name: "Mileage",
							tooltip_description: "Submit mileage claims and get reimbursed in just a few clicks.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aRYiLhIAACIAorv8",
				id: "84018f82-3890-5886-982e-44a7bc1ae055",
				data: {
					title: "Spend controls",
					features: [
						{
							name: "Real-time overview of all expenses",
							tooltip_description: "See card transactions and reimbursements instantly, with full expense data.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Spend analytics",
							tooltip_description: "Track trends with reports and visual analytics dashboards.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Individual card limits",
							tooltip_description: "Set monthly or total spend limits for each card.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Card limits per purchase",
							tooltip_description: "Control spending by setting a maximum transaction amount per purchase.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Temporary limits",
							tooltip_description: "Temporarily raise a card limit for one-off payments or work trips.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Approval workflows",
							tooltip_description: "Auto-assign expenses to reviewers based on reporting lines or amounts.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Spending guidelines",
							tooltip_description: "Create and manage your expense policy in Pleo to reduce out-of-policy spend.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Guidelines assistant",
							tooltip_description: "Answer policy questions in seconds with AI-powered responses",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Advanced approval workflows",
							tooltip_description: "Set up multi-step approvals based on vendor, amount, project, or department tags.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Advanced card controls",
							tooltip_description: "Block specific merchants, weekend spending, or ATM withdrawals.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Budgets",
							tooltip_description: "Track project or department spending in real-time against allocated budgets.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "AI expense review",
							tooltip_description: "Automatically flag transactions that are out of policy.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: "200+"
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMVfxAAACUAj2lk",
				id: "d6463138-5747-5984-ba25-355f1ed7b70e",
				data: {
					title: "Vendor management",
					features: [
						{
							name: "Recurring vendor tracking",
							tooltip_description: "See all recurring card and invoice payments in one dashboard to track and optimise vendor spend.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Advanced vendor insights",
							tooltip_description: "See vendor spend patterns and know who you're paying, at a glance.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Renewal management",
							tooltip_description: "Stay on top of vendor contracts with renewal reminders and centralised tracking.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Spending insights",
							tooltip_description: "Optimise vendor spend with AI-powered insights into recurring spend patterns.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aRYjbxIAACIAor3Y",
				id: "b92d645f-75fc-5244-8145-260cf3a275b5",
				data: {
					title: "Credit and Treasury",
					features: [{
						name: "Transfer rules",
						tooltip_description: "Keep your Pleo Account funded with automated, rule-based top-ups.",
						starter1: true,
						essential1: true,
						advanced1: true,
						beyond1: true,
						starter_excerpt: "1",
						essential_excerpt: "1",
						advanced_excerpt: "1",
						beyond_excerpt: "10+"
					}]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMWKBAAACMAj2p1",
				id: "1ed0cad7-a31d-5073-974c-15430a7e62c1",
				data: {
					title: "Accounting automation",
					features: [
						{
							name: "Custom accounting exports",
							tooltip_description: "Export data in a format that fits your accounting system for seamless bookkeeping.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Custom categories and tags",
							tooltip_description: "Align expenses with your G/L accounts and cost centers using tags and custom categories.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Auto-categorisation",
							tooltip_description: "Let Pleo’s AI automatically assign categories to expenses.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Auto-VAT split",
							tooltip_description: "Automatically calculate and split VAT for faster, more accurate reporting.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "OCR for receipts",
							tooltip_description: "Extract key details from receipts automatically — no manual entry needed.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aRYlARIAACUAosAX",
				id: "708ec297-8ea9-59d3-8b87-72c9027b7ac3",
				data: {
					title: "Organisation Management",
					features: [
						{
							name: "External bookkeeper access",
							tooltip_description: "Grant bookkeepers access to manage expenses and invoices without a full user account.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: "12 €/month",
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Teams management",
							tooltip_description: "Organise employees into teams for better expense oversight and control.",
							starter1: false,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Multi-entity management",
							tooltip_description: "Manage multiple legal entities under one Pleo account.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMXDRAAACQAj2va",
				id: "436b804c-9a40-5373-9726-542599c92f34",
				data: {
					title: "Integrations",
					features: [
						{
							name: "Accounting integrations",
							tooltip_description: "Sync Pleo spending data directly with your accounting system or ERP.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Premium integration",
							tooltip_description: "SAP S/4HANA, SAP Business One, MS Dynamics 365 F&O, Business Central on-premises, Sage Intacct, Visma.net, NetSuite",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: "Add-on"
						},
						{
							name: "HRIS integrations",
							tooltip_description: "Simplify onboarding and offboarding with HR system integrations.",
							starter1: false,
							essential1: false,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMZbRAAACQAj2-W",
				id: "2a66669e-6d9e-5696-8552-282af37f9304",
				data: {
					title: "Security and Compliance",
					features: [
						{
							name: "Bank statement",
							tooltip_description: "Generate a full statement of all Pleo Account transactions.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Transaction statement",
							tooltip_description: "View and download detailed reports of individual transactions.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "SAML SSO (Single Sign On)",
							tooltip_description: "Enable secure, industry-standard authentication with SAML SSO.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMYUxAAACYAj23T",
				id: "c951a38d-a896-5360-93b7-bee778b585cc",
				data: {
					title: "Support",
					features: [
						{
							name: "Help center",
							tooltip_description: null,
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Email support",
							tooltip_description: "Get help from our support team via email.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Chat support",
							tooltip_description: "Chat with our support team in real-time through the Pleo app.",
							starter1: true,
							essential1: true,
							advanced1: true,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Phone support",
							tooltip_description: "Speak to our support team by phone from 9:00 to 17:00 CET, Monday to Friday (excl. bank holidays).",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Assisted onboarding",
							tooltip_description: "Get personalised onboarding sessions with a dedicated Onboarding Manager.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Priority support",
							tooltip_description: "Access priority support with faster resolutions across multiple channels.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						},
						{
							name: "Customer success manager",
							tooltip_description: "Work with an Expert to streamline setup and maximise Pleo’s value.",
							starter1: false,
							essential1: false,
							advanced1: false,
							beyond1: true,
							starter_excerpt: null,
							essential_excerpt: null,
							advanced_excerpt: null,
							beyond_excerpt: null
						}
					]
				}
			} } },
			{ comparison_table: { document: {
				_previewable: "aJMY7BAAACMAj27K",
				id: "7fed4de9-e111-52e8-b71e-54708936f00c",
				data: {
					title: "Foreign exchange fees",
					features: [{
						name: "Card payments: foreign exchange fee",
						tooltip_description: "Fee applied when card transactions are made in a foreign currency.",
						starter1: true,
						essential1: true,
						advanced1: true,
						beyond1: true,
						starter_excerpt: "2.49 %",
						essential_excerpt: "1.99 %",
						advanced_excerpt: "1.99 %",
						beyond_excerpt: "1.49 %"
					}, {
						name: "Invoice payments: foreign exchange fee",
						tooltip_description: "Fee applied when invoices are paid in a foreign currency.",
						starter1: true,
						essential1: true,
						advanced1: true,
						beyond1: true,
						starter_excerpt: "2.49 %",
						essential_excerpt: "1.99 %",
						advanced_excerpt: "1.99 %",
						beyond_excerpt: "1.49 %"
					}]
				}
			} } }
		],
		questions_title: "Questions? We got you",
		questions_answers: [
			{
				question: "What is a virtual Pleo card?",
				answer: { richText: [{
					type: "paragraph",
					text: "A Pleo virtual card is a commercial credit Mastercard® that works just like any other plastic payment card, but is accessible only electronically and can be used for online purchases. Pleo virtual card for business can be a good solution for employees who mainly make purchases online (i.e. subscriptions to online services and tools, e-commerce shops, online bookings and other online purchases) as it is safe and always accessible from your phone or computer.",
					spans: []
				}] }
			},
			{
				question: "Who is the issuer of the Pleo cards?",
				answer: { richText: [{
					type: "paragraph",
					text: "The Pleo Card is issued by Evolve Bank & Trust, pursuant to a license from Mastercard International Incorporated. Evolve Bank & Trust is an FDIC member. All communications should be sent to Pleo North America, Inc., 18th Ave S & Chet Atkins Pl, Nashville, TN 37212.",
					spans: []
				}] }
			},
			{
				question: "Who is behind Pleo?",
				answer: { richText: [{
					type: "paragraph",
					text: "Pleo was founded in early 2015 by fintech veterans Jeppe Rindom and Niccolo Perra, who met while working at the Danish start-up success Tradeshift. The Pleo team is based in Copenhagen and London. The company is financed by Bain Capital Ventures, Thrive Capital, Kinnevik, Creandum and Founders A/S.",
					spans: []
				}] }
			}
		],
		testimonial: { document: {
			id: "713d1e56-b979-5695-9f75-6938afc7629d",
			data: {
				image: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/d66f10ed-0edc-4476-96bc-f7d39519f8d8_Card_Testimonial.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 2240,
						width: 2400
					}
				},
				quote: "We used to spend around 10% of our time on credit card reconciliations a month, and thanks to Pleo this has been reduced to around 2%.",
				attribution_name: "Charlie Maynard",
				attribution_title: "Finance Manager, what3words",
				cta_text: ""
			}
		} },
		social_proof_logos_extended_section: { document: { data: {
			title: { richText: [{
				type: "paragraph",
				text: "Trusted by more than {{numberOfCustomers}} companies",
				spans: [{
					start: 21,
					end: 42,
					type: "strong"
				}]
			}] },
			logos: [
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/c2a10a18-c7ad-48d3-9925-2810aec1b9b6_The%20tab.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 36,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/453bcb34-351e-405f-8e45-7dada18de75a_Drover.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 18,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/81c20a4c-feb4-4bdf-a30b-7b7dbe24adfb_Syft.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 33,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/e6a609c9-7054-4100-b178-772632c9923c_Charlie.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 30,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/8b1012bb-6c6d-4ac5-a0e5-d8b9f30e5b20_Paddle.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 38,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/e0e5c33b-b309-48eb-95ed-6ff0cec64fa0_Planday.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 21,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/9909e6ea-e29c-45ec-a2fd-4c143909aee1_Pizza%20Pilgrims.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 57,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/29671eaa-1bad-462d-b7f8-7abe6976eaa1_Thread.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 21,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/e669c382-c6cb-4d2e-98d3-0f44d5360ccf_Byron.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 60,
						width: 78
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/1ff81091-aa12-4dbd-95c2-715de0e4b3d0_Flux%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 65,
						width: 65
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/859e27eb-8f8b-49bd-bc8e-d9a688acd206_Lyst.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 55,
						width: 100
					}
				} },
				{ logo: {
					alt: "",
					copyright: "",
					url: "https://images.prismic.io/commercial-helios/5ca6d664-efd4-4ed4-9ec9-b148adf40a14_IDC.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
					dimensions: {
						height: 26,
						width: 100
					}
				} }
			]
		} } },
		social_proof_ratings_section: { document: { data: {
			title: { richText: [{
				type: "paragraph",
				text: "Highly rated in all the right places",
				spans: []
			}] },
			ratings: [
				{ rating: { document: { data: {
					logo: {
						alt: "Trustpilot logo",
						copyright: "",
						url: "https://images.prismic.io/commercial-helios/8d4b66a1-bbec-4ead-b3c3-01f0995f65a8_trustpilot-vector-logo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 148,
							width: 601
						}
					},
					stars: "5",
					rating_number: 4,
					link: "https://www.trustpilot.com/review/pleo.io"
				} } } },
				{ rating: { document: { data: {
					logo: {
						alt: "G2 logo",
						copyright: "é",
						url: "https://commercial-helios.cdn.prismic.io/commercial-helios/a49767c4-88c2-4b6f-ae3c-b236df9fbce6_G2_Logo_Red_RGB.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 150,
							width: 150
						}
					},
					stars: "5",
					rating_number: 4.8,
					link: "https://www.g2.com/products/pleo/reviews"
				} } } },
				{ rating: { document: { data: {
					logo: {
						alt: "Capterra logo",
						copyright: "",
						url: "https://images.prismic.io/commercial-helios/ac82880a-40b6-43b9-975f-2f5d44310463_capterralogo.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
						dimensions: {
							height: 345,
							width: 1500
						}
					},
					stars: "5",
					rating_number: 4.9,
					link: "https://www.capterra.com/p/160720/Pleo"
				} } } }
			]
		} } },
		why_pleo: [{
			pre_title: "But that's not all...",
			image: {
				alt: "",
				copyright: "",
				url: "https://images.prismic.io/commercial-helios/f8d355f2-ba1b-4bdc-8101-e08978490ad7_Image.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 1120,
					width: 1200
				}
			},
			title: "Why Pleo",
			body: { richText: [{
				type: "paragraph",
				text: "Pleo offers smart business expense cards that enable employees to buy the things they need for work, all while keeping a company's finance director in control of spending.",
				spans: []
			}, {
				type: "paragraph",
				text: "Simplify bookkeeping, eliminate expense reports, revolutionise your business. Power to your people.",
				spans: []
			}] }
		}],
		signup_banner: { document: null }
	},
	pricingTiers: {
		lang: "en-us",
		data: {
			title_image: {
				alt: null,
				copyright: null,
				url: null,
				dimensions: null
			},
			billing_cycle: [{
				billed_monthly_label: "Billed monthly",
				billed_yearly_label: "Billed yearly",
				description: "Get Pleo for less with yearly billing",
				legend: "Choose billing"
			}],
			form_production: {
				formId: "48b4ed80-339b-459d-ac29-3c9a28333914",
				consents: {
					type: "implicit_consent_to_process",
					communicationConsents: [{
						id: 5355469,
						required: false
					}]
				}
			},
			form_staging: {
				formId: "5b60dfe6-c06c-4f60-a7bd-79672ae09f82",
				consents: {
					type: "explicit_consent_to_process",
					communicationConsents: [{
						id: 108196403,
						required: false
					}]
				}
			},
			signup_modal_free: [{
				image: { fluid: { base64: "data:image/svg+xml;base64,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" } },
				title: "Get started for free",
				subtitle: "for up to 3 users",
				highlighted_feature_1: null,
				highlighted_feature_2: null,
				highlighted_feature_3: null
			}],
			signup_modal_pro: [{
				image: { fluid: { base64: "data:image/svg+xml;base64,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" } },
				title: "Get started with Pleo",
				subtitle: null,
				highlighted_feature_1: null,
				highlighted_feature_2: null,
				highlighted_feature_3: null
			}],
			show_ctas: false,
			pricing_tiers: [
				{ pricing_tier: { document: { data: {
					name: "Essential",
					per_month_text: "per month",
					cost_subtext: "3 users included",
					excerpt: "Manage expenses and accounts all in one place",
					cta_text: "Try for free",
					features_title: "All the benefits of Essential:",
					features: [
						{
							feature: "Physical and virtual cards",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Accounting system integrations",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Chat support",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Reimbursements",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Mileage",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "AI-powered spend guidelines",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Flexible card limits",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Approval workflows",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Recurring vendor tracking",
							disabled_monthly: false,
							is_highlighted: false
						}
					],
					annual_cost: "$39",
					monthly_cost: "$45",
					monthly_billing_screen_reader_alt: "Monthly cost is",
					annual_billing_screen_reader_alt: "Yearly cost is",
					monthly_cost_subtext_extra: "$13 /additional user per month",
					annual_cost_subtext_extra: "$11 /additional user per month"
				} } } },
				{ pricing_tier: { document: { data: {
					name: "Advanced",
					per_month_text: "per month",
					cost_subtext: "3 users included",
					excerpt: "Get complete control over spend with advanced approvals and budgets",
					cta_text: "Book a demo",
					features_title: "Everything in Essential, plus:",
					features: [
						{
							feature: "Cashback*",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Advanced card controls",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Budgets",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "HRIS integrations",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Advanced approval workflows",
							disabled_monthly: false,
							is_highlighted: false
						}
					],
					footnote: "for eligible customers",
					annual_cost: "$99",
					monthly_cost: "$109",
					monthly_billing_screen_reader_alt: "Monthly cost is",
					annual_billing_screen_reader_alt: "Yearly cost is",
					monthly_cost_subtext_extra: "$17 /additional user per month",
					annual_cost_subtext_extra: "$15 /additional user per month"
				} } } },
				{ pricing_tier: { document: { data: {
					name: "Business",
					per_month_text: "per month",
					cost_subtext: "Bespoke",
					excerpt: "Scale spend and controls across multiple entities with deep integrations for complex operations",
					cta_text: "Book a demo",
					features_title: "Everything in Advanced, plus:",
					features: [
						{
							feature: "Multi-entity management",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Premium integrations**",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "AI-powered expense review",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Advanced vendor management",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Cash management",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Spending insights",
							disabled_monthly: false,
							is_highlighted: false
						},
						{
							feature: "Assisted onboarding",
							disabled_monthly: false,
							is_highlighted: false
						}
					],
					footnote: "",
					second_footnote: "available as add-on",
					annual_cost: "$249",
					monthly_cost: "$249",
					monthly_billing_screen_reader_alt: "Monthly cost is",
					annual_billing_screen_reader_alt: "Yearly cost is",
					monthly_cost_subtext_extra: "",
					annual_cost_subtext_extra: ""
				} } } }
			]
		}
	}
};
//#endregion
//#region src/adapters/static/legal-page.ts
const legalPage = {
	meta_title: "Legal Page",
	meta_description: "Here's the important legal stuff, in one place.",
	open_graph_image: {
		alt: null,
		copyright: null,
		url: "https://images.prismic.io/commercial-helios/168485c2-f845-431f-93d0-fe4b5e598906_meta-about-us-01.jpg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
		dimensions: {
			height: 685,
			width: 1300
		}
	},
	title: "Here's the important legal stuff, in one place.",
	legalDocs: {
		_previewable: "X-CEcBIAAMip1qtz",
		data: {
			title: "Are you looking for...",
			documents: [
				{
					title: "Master Service Agreement",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pathward-msa.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Cardholder Agreement",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pathward-cardholder-agreement.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Authorized User Disclosure",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pathward-user-disclosures.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Pathward Privacy Policy",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pathward-privacy-notice.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Pleo Privacy Policy",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-us.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Fraud Awareness",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pleo-fraud-awareness-us.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "Complaint Process",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pleo-complaint-process-na.pdf"
					},
					link_text: "Download PDF"
				},
				{
					title: "AI Access Terms",
					link: {
						link_type: "Web",
						uid: null,
						type: null,
						lang: null,
						target: null,
						url: "https://www.pleo.io/legal-documents/pleo-ai-access-terms-en.pdf"
					},
					link_text: "Download PDF"
				}
			]
		}
	}
};
//#endregion
//#region src/adapters/static/demo-page.ts
const demoPage = {
	meta_title: null,
	meta_description: null,
	open_graph_image: {
		alt: null,
		copyright: null,
		url: null,
		dimensions: null
	},
	title: "The spending solution that saves time and money",
	bullet_points: [
		{
			icon: {
				alt: null,
				copyright: null,
				url: "https://prismic-io.s3.amazonaws.com/commercial-helios/53b98ca1-cc17-408c-8904-daaa571cf2e8_analytics-icon.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 50,
					width: 50
				}
			},
			text: "100% visibility on all spending"
		},
		{
			icon: {
				alt: null,
				copyright: null,
				url: "https://prismic-io.s3.amazonaws.com/commercial-helios/269c8388-1237-4ef4-b735-3c1a101f4b26_match%20receipt.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 80,
					width: 80
				}
			},
			text: "Automate expense reports and reconciliation"
		},
		{
			icon: {
				alt: null,
				copyright: null,
				url: "https://prismic-io.s3.amazonaws.com/commercial-helios/51570409-7fb2-4c1b-983a-3480904180d8_buy-something-icon.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 50,
					width: 50
				}
			},
			text: "Save time on collecting receipts and paperwork"
		}
	],
	form_title: "Ready, set, Pleo!",
	form_production: {
		formId: "7cbfe771-1f1e-4f22-96a3-ba4dc487475f",
		consents: {
			type: "implicit_consent_to_process",
			communicationConsents: [{
				id: 5355469,
				required: true
			}]
		}
	},
	form_staging: {
		formId: "7efdd83b-b1fd-4d83-90dc-14c7da4263d1",
		consents: {
			type: "implicit_consent_to_process",
			communicationConsents: [{
				id: 5355469,
				required: true
			}]
		}
	},
	imperative_consents_production: [],
	imperative_consents_staging: [],
	social_proof_logos_section: { document: { data: {
		title: "One spending solution, {{numberOfCustomers}} happy companies",
		logos: [
			{ logo: {
				alt: null,
				copyright: null,
				url: "https://commercial-helios.cdn.prismic.io/commercial-helios/53d1e19a-6258-45cf-b841-156bd8240cb3_Byron.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 60,
					width: 100
				}
			} },
			{ logo: {
				alt: null,
				copyright: null,
				url: "https://commercial-helios.cdn.prismic.io/commercial-helios/3e0d68c7-6c43-46e2-9cda-227d5b0c2a86_Lyst.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 60,
					width: 100
				}
			} },
			{ logo: {
				alt: null,
				copyright: null,
				url: "https://commercial-helios.cdn.prismic.io/commercial-helios/f06d6844-ba0d-4078-8887-b574e8905b69_IDC.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 60,
					width: 100
				}
			} },
			{ logo: {
				alt: null,
				copyright: null,
				url: "https://commercial-helios.cdn.prismic.io/commercial-helios/1ff81091-aa12-4dbd-95c2-715de0e4b3d0_Flux%201.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 65,
					width: 65
				}
			} }
		]
	} } }
};
//#endregion
//#region src/adapters/static/homepage.ts
const homepage = [
	{
		__typename: "PrismicHomepageV4DataBodyVideoHero",
		primary: {
			title: "Stop spending time on expenses",
			lead_text: { richText: [{
				type: "paragraph",
				text: "Do more of the work that matters. Centralize your business spending for complete financial efficiency and balance the books effortlessly with Pleo.",
				spans: [],
				direction: "ltr"
			}] },
			signup_label: "Get Started",
			cta_text: "Explore",
			cta_link: {
				link_type: "Document",
				uid: "explore-product",
				type: "explore_product",
				lang: "en-us",
				target: null,
				url: "/us/explore-product"
			},
			video_mp4: { url: "https://commercial-helios.cdn.prismic.io/commercial-helios/5950bf47-1a76-4ed1-bbf4-1baea93b6fc2_demo-hero-video-compressed.mp4" },
			video_webm: { url: "https://commercial-helios.cdn.prismic.io/commercial-helios/6b59d43a-1bf3-43da-98b7-c89f79f5da08_demo-hero-video.webm" },
			video_poster_image: {
				alt: null,
				copyright: null,
				url: "https://images.prismic.io/commercial-helios/6a3cecb6-9355-46db-8f04-378bb3c69d60_interactive-demo-hero-poster-2.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max",
				dimensions: {
					height: 744,
					width: 1240
				}
			}
		},
		items: []
	},
	{
		__typename: "PrismicHomepageV4DataBodyFeatureBlock",
		primary: {
			title_over_section: null,
			title: "All of your expenses, covered",
			inverse: false,
			background: "default",
			headline: null,
			description: { richText: [{
				type: "paragraph",
				text: "Issue Pleo’s smart company cards with individual spending limits. Your team can buy what they need, while we sort the paperwork automatically.",
				spans: [],
				direction: "ltr"
			}] },
			pre_cta_links: { richText: [] },
			is_circular_image: false,
			cta_label: null,
			predefined_feature_block: { document: null },
			cta_link: {
				link_type: "Any",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: null
			},
			cta_hash_link: null,
			image: {
				alt: null,
				copyright: null,
				url: "https://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?auto=format,compress",
				dimensions: {
					height: 1200,
					width: 1200
				},
				gatsbyImageData: {
					images: {
						sources: [],
						fallback: {
							src: "https://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?ixlib=gatsbyFP&auto=format%2Ccompress&fit=max&w=1200&h=1200",
							srcSet: "https://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?ixlib=gatsbyFP&auto=format%2Ccompress&fit=max&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?ixlib=gatsbyFP&auto=format%2Ccompress&fit=max&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?ixlib=gatsbyFP&auto=format%2Ccompress&fit=max&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/Zsg8kEaF0TcGJWPE_asset_expenses_covered_us.jpg?ixlib=gatsbyFP&auto=format%2Ccompress&fit=max&w=1200&h=1200 1200w",
							sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
						}
					},
					layout: "constrained",
					width: 1200,
					height: 1200
				}
			},
			wistia_video_id: null,
			video_mp4: { url: null },
			video_webm: { url: null }
		}
	},
	{
		__typename: "PrismicHomepageV4DataBodyFeatureBlock",
		primary: {
			title_over_section: null,
			title: "Real-time overview",
			inverse: true,
			background: "default",
			headline: null,
			description: { richText: [{
				type: "paragraph",
				text: "Admins get the details they need on every purchase. Something doesn’t look right? Just tap a button to flag it or if you need, freeze your business expense card.",
				spans: [],
				direction: "ltr"
			}] },
			pre_cta_links: { richText: [] },
			is_circular_image: false,
			cta_label: null,
			predefined_feature_block: { document: null },
			cta_link: {
				link_type: "Any",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: null
			},
			cta_hash_link: null,
			image: {
				alt: null,
				copyright: null,
				url: "https://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=1120&h=1120",
				dimensions: {
					height: 1120,
					width: 1120
				},
				gatsbyImageData: {
					images: {
						sources: [],
						fallback: {
							src: "https://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=1120&h=1120",
							srcSet: "https://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=720&h=720 720w,\nhttps://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=940&h=940 940w,\nhttps://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=1080&h=1080 1080w,\nhttps://images.prismic.io/commercial-helios/526ddf47-2f4f-4e97-b1fb-1d82e9ed051c_02_automated_expense_reports_UK_01.png?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&rect=0%2C0%2C1120%2C1120&w=1120&h=1120 1120w",
							sizes: "(max-width: 767px) calc(100vw - 2 * 24px), (max-width: 991px) calc(40vw - 3 * 24px), (max-width: 1439px) calc(55vw - 3 * 40px), 600px"
						}
					},
					layout: "constrained",
					width: 1120,
					height: 1120
				}
			},
			wistia_video_id: null,
			video_mp4: { url: "https://commercial-helios.cdn.prismic.io/commercial-helios/245ade65-df96-4d18-b979-eb03815280a8_02_manage_company_spend.mp4" },
			video_webm: { url: "https://commercial-helios.cdn.prismic.io/commercial-helios/d23cabc1-1194-4f36-8e63-5e82d42c5b45_02_manage_company_spend.webm" }
		}
	}
];
//#endregion
//#region src/adapters/static/site-meta.ts
const siteMeta = {
	siteName: "Pleo",
	facebookAppId: "pleo.io",
	facebookDomainVerification: "k2i8qi1dqf0k41b7r44p87smjwnhay"
};
//#endregion
//#region src/mappers/website/footer.ts
const mapLinks = (links) => links.map((link) => ({
	text: link.text,
	href: link.link.url
})).filter((link) => link.href !== null);
const mapFooter = (raw, socialLinks) => {
	const groups = [
		{
			heading: raw.product_heading,
			links: raw.product_links
		},
		{
			heading: raw.company_heading,
			links: raw.company_links
		},
		...raw.partnerships_heading ? [{
			heading: raw.partnerships_heading,
			links: raw.partnerships_links
		}] : [],
		{
			heading: raw.resources_heading,
			links: raw.resources_links
		},
		{
			heading: raw.solutions_heading,
			links: raw.solutions_links
		},
		{
			heading: raw.legal_heading,
			links: raw.legal_links
		}
	];
	return {
		entity: raw.entity,
		addressLines: raw.address.map((line) => line.text),
		terms: raw.terms_body,
		copyright: raw.copyright_text,
		financialPartnerCopyright: raw.financial_partner_copyright_text ?? void 0,
		linkGroups: groups.map(({ heading, links }) => ({
			heading,
			links: mapLinks(links)
		})).filter(({ links }) => links.length > 0),
		socialLinks: socialLinks.map((link) => ({
			platform: link.platform,
			name: link.name,
			url: link.url
		}))
	};
};
//#endregion
//#region src/mappers/website/locale-seo.ts
const toOgLocale = (htmlLang) => {
	const [language, region] = htmlLang.split("-");
	return region ? `${language}_${region.toUpperCase()}` : language;
};
const defaultLocale = locales.find((locale) => locale.default) ?? locales[0];
const localePath = (urlCode, slug) => slug ? `/${urlCode}/${slug}` : `/${urlCode}`;
const getLocaleSeoMeta = (urlCode, slug) => {
	const currentLocale = locales.find((locale) => locale.urlCode === urlCode) ?? locales.find((locale) => locale.default) ?? locales[0];
	return {
		ogLocale: toOgLocale(currentLocale.htmlLang),
		ogLocaleAlternates: locales.filter((locale) => locale.urlCode !== currentLocale.urlCode).map((locale) => toOgLocale(locale.htmlLang)),
		languageAlternates: [...locales.map((locale) => ({
			hrefLang: locale.htmlLang,
			href: localePath(locale.urlCode, slug)
		})), {
			hrefLang: "x-default",
			href: localePath(defaultLocale.urlCode, slug)
		}]
	};
};
//#endregion
//#region src/mappers/website/page-meta.ts
const toSocialImageUrl = (url) => {
	const [base, existingParams] = url.split("?");
	const params = new URLSearchParams(existingParams);
	params.set("fit", "crop");
	params.set("w", "1200");
	params.set("h", "630");
	params.set("dpr", "2");
	return `${base}?${params.toString()}`;
};
const mapPageMeta = (raw) => {
	const title = raw.title === siteMeta.siteName ? raw.title : `${raw.title} - ${siteMeta.siteName}`;
	return {
		...siteMeta,
		...getLocaleSeoMeta(raw.urlCode, raw.slug),
		title,
		description: raw.description ?? void 0,
		ogImageUrl: raw.ogImageUrl ? toSocialImageUrl(raw.ogImageUrl) : void 0
	};
};
//#endregion
//#region src/mappers/website/not-found-page.ts
const mapNotFoundPage = (raw) => {
	const { data } = raw;
	return {
		title: data.title,
		body: data.body,
		ctaText: data.cta_text,
		ctaHref: data.cta_link.url,
		meta: mapPageMeta({
			title: data.meta_title ?? data.title,
			description: data.meta_description,
			ogImageUrl: data.open_graph_image.url,
			urlCode: "us"
		})
	};
};
//#endregion
//#region src/namespaces/website.ts
const Website = {
	getHeader: () => {
		return mapHeader(header);
	},
	getFooter: () => {
		return mapFooter(footer, socialLinks);
	},
	getNotFoundPage: () => {
		return mapNotFoundPage(notFoundPage);
	},
	getAllPages: () => [
		{
			locale: "us",
			slug: void 0,
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us"
			}),
			components: []
		},
		{
			locale: "us",
			slug: "pricing",
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us",
				slug: "pricing"
			}),
			components: []
		},
		{
			locale: "us",
			slug: "demo",
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us",
				slug: "demo"
			}),
			components: []
		},
		{
			locale: "us",
			slug: "getting-started",
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us",
				slug: "getting-started"
			}),
			components: []
		},
		{
			locale: "us",
			slug: "explore-product",
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us",
				slug: "explore-product"
			}),
			components: []
		},
		{
			locale: "us",
			slug: "legal",
			meta: mapPageMeta({
				title: legalPage.meta_title,
				description: legalPage.meta_description,
				ogImageUrl: legalPage.open_graph_image.url,
				urlCode: "us",
				slug: "legal"
			}),
			components: [{
				type: "heading",
				title: legalPage.title
			}, {
				type: "legal-documents-grid",
				title: legalPage.legalDocs.data.title,
				documents: legalPage.legalDocs.data.documents.map((doc) => ({
					title: doc.title,
					linkText: doc.link_text,
					href: doc.link.url
				}))
			}]
		},
		...slicePage.map(({ uid }) => ({
			locale: "us",
			slug: uid,
			meta: mapPageMeta({
				title: "Pleo",
				urlCode: "us",
				slug: uid
			}),
			components: []
		}))
	]
};
//#endregion
//#region src/adapters/ashby/fetchers.ts
const ASHBY_JOB_POSTINGS_API = "https://api.ashbyhq.com/posting-api/job-board/pleo";
const fetchJobListings = async () => {
	const response = await fetch(ASHBY_JOB_POSTINGS_API);
	if (!response.ok) throw new Error(`Failed to fetch job listings from ${ASHBY_JOB_POSTINGS_API}: ${response.status} ${response.statusText}`);
	return response.json();
};
//#endregion
//#region src/adapters/prismic/client.ts
const client = prismic.createClient("commercial-helios", { accessToken: process.env.PRISMIC_ACCESS_TOKEN });
//#endregion
//#region src/adapters/prismic/fetchers.ts
/**
* Node resolves `.js` to `.ts` at compile time, which is verified in CI.
*
* The `.js` extension is added deliberately so the source stays compatible
* when we introduce ESM output later, avoiding potential build issues
* during the migration.
*/
const fetchRawNotFoundPage = async () => await client.getByType("not_found_page", { lang: "*" });
//#endregion
//#region src/adapters/prismic/utils/build-alternative-paths.ts
const buildAlternativePaths = (locales, currentLang) => {
	const paths = {};
	locales.forEach((locale) => {
		paths[locale.code] = `/${locale.urlCode}/404`;
	});
	const { [currentLang]: _, ...alternativePaths } = { ...paths };
	return alternativePaths;
};
//#endregion
//#region src/adapters/prismic/utils/normalize-prismic-link.ts
function normalizePrismicLink(raw) {
	if (!isFilled.link(raw)) return;
	switch (raw.link_type) {
		case "Web": return {
			link_type: "Web",
			url: raw.url,
			target: raw.target
		};
		case "Media": return {
			link_type: "Media",
			url: raw.url
		};
		case "Document": {
			const doc = raw;
			if (!isSupportedLocale(doc.lang)) return;
			return {
				link_type: "Document",
				uid: doc.uid ?? null,
				type: doc.type ?? "",
				lang: doc.lang,
				url: doc.url
			};
		}
		default: return;
	}
}
//#endregion
//#region src/mappers/gatsby/404-page.ts
const map404Page = (raw) => raw.results.filter((result) => isSupportedLocale(result.lang)).map((result) => ({
	content: {
		title: result.data.title || void 0,
		body: result.data.body || void 0,
		ctaText: result.data.cta_text || void 0,
		ctaLink: normalizePrismicLink(result.data.cta_link)
	},
	meta: {
		id: result.id,
		uid: result.uid,
		type: result.type,
		lang: result.lang,
		alternateLanguages: result.alternate_languages.filter((alt) => isSupportedLocale(alt.lang)).map((alt) => ({
			...alt,
			lang: alt.lang
		})),
		firstPublished: result.first_publication_date,
		lastPublished: result.last_publication_date || null,
		title: result.data.meta_title || void 0,
		description: result.data.meta_description || void 0,
		ogImageUrl: result.data.open_graph_image?.url || void 0,
		excludeFromSitemap: result.data.exclude_sitemap,
		alternativePaths: buildAlternativePaths(locales, result.lang)
	},
	settings: {}
}));
//#endregion
//#region src/mappers/gatsby/job-listings.ts
const mapJobListings = (raw) => raw.jobs.map((job) => {
	const primaryLocationWithWorkplace = `${job.workplaceType ? `${job.workplaceType} - ` : ""}${job.location}`;
	return {
		title: job.title,
		absoluteUrl: job.jobUrl,
		departments: [{ name: job.department }],
		offices: [{ name: primaryLocationWithWorkplace }, ...job.secondaryLocations.map(({ location }) => ({ name: location }))]
	};
});
//#endregion
//#region src/mappers/gatsby/slice-page.ts
const mapSlicePage = (raw) => raw.map(({ uid, ...content }) => ({
	uid,
	content
}));
//#endregion
//#region src/namespaces/gatsby.ts
const Gatsby = {
	get404Page: async () => {
		const raw = await fetchRawNotFoundPage();
		return map404Page({
			...raw,
			results: [...raw.results, notFoundPage]
		});
	},
	getJobListings: async () => {
		return mapJobListings(await fetchJobListings());
	},
	getGettingStartedExperiencePage: () => {
		return gettingStartedExperiencePage;
	},
	getPricingPage: () => {
		return pricingPage;
	},
	getLegalPage: () => {
		return legalPage;
	},
	getExploreProductPage: () => {
		return exploreProductPage;
	},
	getSlicePage: () => {
		return mapSlicePage(slicePage);
	},
	getDemoPage: () => {
		return demoPage;
	},
	getHomepage: () => {
		return homepage;
	}
};
//#endregion
export { Gatsby, GatsbyClient, PrismicLinkTypeEnum, Website, getLanguageName, isSupportedLocale, localeCodeToUrl, locales };
